import { Instance, types } from 'mobx-state-tree'

const EMIPlan = types.model('EMIPlan', {
  allowZeroCost: types.optional(types.string, ''),
  metadata: types.optional(types.string, ''),
  productDiscount: types.optional(types.string, ''),
  productDiscountPercentage: types.optional(types.string, ''),
  programType: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  subventionCashbackDiscount: types.optional(types.string, ''),
  subventionCashbackDiscountPercentage: types.optional(types.string, ''),
})

const Product = types.model('Product', {
  emiPlan: types.optional(EMIPlan, {}),
  productId: types.optional(types.string, ''),
  productAmount: types.optional(types.string, ''),
  productValidationKey: types.optional(types.string, ''),
  productValidationValue: types.optional(types.string, ''),
})

const ConvenienceFee = types.model('ConvenienceFee', {
  type: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  tax: types.optional(types.string, ''),
  taxPercentage: types.optional(types.string, ''),
  // feeAddtnTaxAmount: types.optional(types.string, ''),
  // feeAddtnTaxPercent: types.optional(types.string, ''),
  // feeAmount: types.optional(types.string, ''),
  // feeCgstAmount: types.optional(types.string, ''),
  // feeCgstPercent: types.optional(types.string, ''),
  // feeIgstAmount: types.optional(types.string, ''),
  // feeIgstPercent: types.optional(types.string, ''),
  // feePercent: types.optional(types.string, ''),
  // feeSgstAmount: types.optional(types.string, ''),
  // feeSgstPercent: types.optional(types.string, ''),
  // feeTotalGstAmount: types.optional(types.string, ''),
  // feeTotalGstPercent: types.optional(types.string, ''),
  // feeType: types.optional(types.string, ''),
  // feeUgstAmount: types.optional(types.string, ''),
  // feeUgstPercent: types.optional(types.string, ''),
})

const ProcessingFee = types.model('ProcessingFee', {
  type: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  tax: types.optional(types.string, ''),
  taxPercentage: types.optional(types.string, ''),
  // feeAddtnTaxAmount: types.optional(types.string, ''),
  // feeAddtnTaxPercent: types.optional(types.string, ''),
  // feeAmount: types.optional(types.string, ''),
  // feeCgstAmount: types.optional(types.string, ''),
  // feeCgstPercent: types.optional(types.string, ''),
  // feeIgstAmount: types.optional(types.string, ''),
  // feeIgstPercent: types.optional(types.string, ''),
  // feePercent: types.optional(types.string, ''),
  // feeSgstAmount: types.optional(types.string, ''),
  // feeSgstPercent: types.optional(types.string, ''),
  // feeTotalGstAmount: types.optional(types.string, ''),
  // feeTotalGstPercent: types.optional(types.string, ''),
  // feeType: types.optional(types.string, ''),
  // feeUgstAmount: types.optional(types.string, ''),
  // feeUgstPercent: types.optional(types.string, ''),
})

const CardlessEMI = types.model('CardlessEMI', {
  bank: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  bankImageUrl: types.optional(types.string, ''),
  termsAndConditions: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  tenure: types.optional(types.string, ''),
  schemeType: types.optional(types.string, ''),
  schemeSubType: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  interestRate: types.optional(types.string, ''),
  interest: types.optional(types.string, ''),
  discount: types.optional(types.string, ''),
  cashBack: types.optional(types.string, ''),
  schemeNote: types.optional(types.string, ''),
  planSource: types.optional(types.string, '0'),
  metadata: types.optional(types.string, ''),
  grossAmount: types.optional(types.string, ''),
  netAmount: types.optional(types.string, ''),
  totalAmount: types.optional(types.string, ''),
  processingFees: types.optional(ProcessingFee, {}),
  convenienceFees: types.optional(ConvenienceFee, {}),
  product: types.array(Product),
  paymentType: types.optional(types.string, 'CardlessEMI'),
})

export type CardlessEMIType = Instance<typeof CardlessEMI>
export { CardlessEMI }
